export const countryOptions = [
    { value: "AFGHANISTAN", label: "Afghanistan", code: "AFG" },
    { value: "ALAND ISLANDS", label: "Åland Islands", code: "ALA" },
    { value: "ALBANIA", label: "Albania", code: "ALB" },
    { value: "ALGERIA", label: "Algeria", code: "DZA" },
    { value: "AMERICAN SAMOA", label: "American Samoa", code: "ASM" },
    { value: "ANDORRA", label: "Andorra", code: "AND" },
    { value: "ANGOLA", label: "Angola", code: "AGO" },
    { value: "ANGUILLA", label: "Anguilla", code: "AIA" },
    { value: "ANTARCTICA", label: "Antarctica", code: "ATA" },
    { value: "ANTIGUA AND BARBUDA", label: "Antigua and Barbuda", code: "ATG" },
    { value: "ARGENTINA", label: "Argentina", code: "ARG" },
    { value: "ARMENIA", label: "Armenia", code: "ARM" },
    { value: "ARUBA", label: "Aruba", code: "ABW" },
    { value: "AUSTRALIA", label: "Australia", code: "AUS" },
    { value: "AUSTRIA", label: "Austria", code: "AUT" },
    { value: "AZERBAIJAN", label: "Azerbaijan", code: "AZE" },
    { value: "BAHAMAS", label: "Bahamas", code: "BHS" },
    { value: "BAHRAIN", label: "Bahrain", code: "BHR" },
    { value: "BANGLADESH", label: "Bangladesh", code: "BGD" },
    { value: "BARBADOS", label: "Barbados", code: "BRB" },
    { value: "BELARUS", label: "Belarus", code: "BLR" },
    { value: "BELGIUM", label: "Belgium", code: "BEL" },
    { value: "BELIZE", label: "Belize", code: "BLZ" },
    { value: "BENIN", label: "Benin", code: "BEN" },
    { value: "BERMUDA", label: "Bermuda", code: "BMU" },
    { value: "BHUTAN", label: "Bhutan", code: "BTN" },
    { value: "BOLIVIA", label: "Bolivia", code: "BOL" },
    { value: "BONAIRE, SINT EUSTATIUS AND SABA", label: "Bonaire, Sint Eustatius and Saba", code: "BES" },
    { value: "BOSNIA AND HERZEGOVINA", label: "Bosnia and Herzegovina", code: "BIH" },
    { value: "BOTSWANA", label: "Botswana", code: "BWA" },
    { value: "BOUVET ISLAND", label: "Bouvet Island", code: "BVT" },
    { value: "BRAZIL", label: "Brazil", code: "BRA" },
    { value: "BRITISH INDIAN OCEAN TERRITORY", label: "British Indian Ocean Territory", code: "IOT" },
    { value: "BRUNEI DARUSSALAM", label: "Brunei Darussalam", code: "BRN" },
    { value: "BULGARIA", label: "Bulgaria", code: "BGR" },
    { value: "BURKINA FASO", label: "Burkina Faso", code: "BFA" },
    { value: "BURUNDI", label: "Burundi", code: "BDI" },
    { value: "CABO VERDE", label: "Cabo Verde", code: "CPV" },
    { value: "CAMBODIA", label: "Cambodia", code: "KHM" },
    { value: "CAMEROON", label: "Cameroon", code: "CMR" },
    { value: "CANADA", label: "Canada", code: "CAN" },
    { value: "CAYMAN ISLANDS", label: "Cayman Islands", code: "CYM" },
    { value: "CENTRAL AFRICAN REPUBLIC", label: "Central African Republic", code: "CAF" },
    { value: "CHAD", label: "Chad", code: "TCD" },
    { value: "CHILE", label: "Chile", code: "CHL" },
    { value: "CHINA", label: "China", code: "CHN" },
    { value: "CHRISTMAS ISLAND", label: "Christmas Island", code: "CXR" },
    { value: "COCOS (KEELING) ISLANDS", label: "Cocos (Keeling) Islands", code: "CCK" },
    { value: "COLOMBIA", label: "Colombia", code: "COL" },
    { value: "COMOROS", label: "Comoros", code: "COM" },
    { value: "CONGO", label: "Congo", code: "COG" },
    { value: "CONGO, DEMOCRATIC REPUBLIC OF THE", label: "Congo, Democratic Republic of the", code: "COD" },
    { value: "COOK ISLANDS", label: "Cook Islands", code: "COK" },
    { value: "COSTA RICA", label: "Costa Rica", code: "CRI" },
    { value: "CROATIA", label: "Croatia", code: "HRV" },
    { value: "CUBA", label: "Cuba", code: "CUB" },
    { value: "CURACAO", label: "Curaçao", code: "CUW" },
    { value: "CYPRUS", label: "Cyprus", code: "CYP" },
    { value: "CZECHIA", label: "Czechia", code: "CZE" },
    { value: "COTE D IVOIRE", label: "Côte d'Ivoire", code: "CIV"},
    { value: "DENMARK", label: "Denmark", code: "DNK" },
    { value: "DJIBOUTI", label: "Djibouti", code: "DJI" },
    { value: "DOMINICA", label: "Dominica", code: "DMA" },
    { value: "DOMINICAN REPUBLIC", label: "Dominican Republic", code: "DOM" },
    { value: "ECUADOR", label: "Ecuador", code: "ECU" },
    { value: "EGYPT", label: "Egypt", code: "EGY" },
    { value: "EL SALVADOR", label: "El Salvador", code: "SLV" },
    { value: "EQUATORIAL GUINEA", label: "Equatorial Guinea", code: "GNQ" },
    { value: "ERITREA", label: "Eritrea", code: "ERI" },
    { value: "ESTONIA", label: "Estonia", code: "EST" },
    { value: "ESWATINI", label: "Eswatini", code: "SWZ" },
    { value: "ETHIOPIA", label: "Ethiopia", code: "ETH" },
    { value: "FALKLAND ISLANDS (MALVINAS)", label: "Falkland Islands (Malvinas)", code: "FLK" },
    { value: "FAROE ISLANDS", label: "Faroe Islands", code: "FRO" },
    { value: "FIJI", label: "Fiji", code: "FJI" },
    { value: "FINLAND", label: "Finland", code: "FIN" },
    { value: "FRANCE", label: "France", code: "FRA" },
    { value: "FRENCH GUIANA", label: "French Guiana", code: "GUF" },
    { value: "FRENCH POLYNESIA", label: "French Polynesia", code: "PYF" },
    { value: "FRENCH SOUTHERN TERRITORIES", label: "French Southern Territories", code: "ATF" },
    { value: "GABON", label: "Gabon", code: "GAB" },
    { value: "GAMBIA", label: "Gambia", code: "GMB" },
    { value: "GEORGIA", label: "Georgia", code: "GEO" },
    { value: "GERMANY", label: "Germany", code: "DEU" },
    { value: "GHANA", label: "Ghana", code: "GHA" },
    { value: "GIBRALTAR", label: "Gibraltar", code: "GIB" },
    { value: "GREECE", label: "Greece", code: "GRC" },
    { value: "GREENLAND", label: "Greenland", code: "GRL" },
    { value: "GRENADA", label: "Grenada", code: "GRD" },
    { value: "GUADELOUPE", label: "Guadeloupe", code: "GLP" },
    { value: "GUAM", label: "Guam", code: "GUM" },
    { value: "GUATEMALA", label: "Guatemala", code: "GTM" },
    { value: "GUERNSEY", label: "Guernsey", code: "GGY" },
    { value: "GUINEA", label: "Guinea", code: "GIN" },
    { value: "GUINEA-BISSAU", label: "Guinea-Bissau", code: "GNB" },
    { value: "GUYANA", label: "Guyana", code: "GUY" },
    { value: "HAITI", label: "Haiti", code: "HTI" },
    { value: "HEARD ISLAND AND MCDONALD ISLANDS", label: "Heard Island and McDonald Islands", code: "HMD" },
    { value: "HOLY SEE", label: "Holy See", code: "VAT" },
    { value: "HONDURAS", label: "Honduras", code: "HND" },
    { value: "HONG KONG", label: "Hong Kong", code: "HKG" },
    { value: "HUNGARY", label: "Hungary", code: "HUN" },
    { value: "ICELAND", label: "Iceland", code: "ISL" },
    { value: "INDIA", label: "India", code: "IND" },
    { value: "INDONESIA", label: "Indonesia", code: "IDN" },
    { value: "IRAN", label: "Iran", code: "IRN" },
    { value: "IRAQ", label: "Iraq", code: "IRQ" },
    { value: "IRELAND", label: "Ireland", code: "IRL" },
    { value: "ISLE OF MAN", label: "Isle of Man", code: "IMN" },
    { value: "ISRAEL", label: "Israel", code: "ISR" },
    { value: "ITALY", label: "Italy", code: "ITA" },
    { value: "JAMAICA", label: "Jamaica", code: "JAM" },
    { value: "JAPAN", label: "Japan", code: "JPN" },
    { value: "JERSEY", label: "Jersey", code: "JEY" },
    { value: "JORDAN", label: "Jordan", code: "JOR" },
    { value: "KAZAKHSTAN", label: "Kazakhstan", code: "KAZ" },
    { value: "KENYA", label: "Kenya", code: "KEN" },
    { value: "KIRIBATI", label: "Kiribati", code: "KIR" },
    { value: "KOREA (NORTH)", label: "Korea, North", code: "PRK" },
    { value: "KOREA (SOUTH)", label: "Korea, South", code: "KOR" },
    { value: "KUWAIT", label: "Kuwait", code: "KWT" },
    { value: "KYRGYZSTAN", label: "Kyrgyzstan", code: "KGZ" },
    { value: "LAO PEOPLE'S DEMOCRATIC REPUBLIC", label: "Laos", code: "LAO" },
    { value: "LATVIA", label: "Latvia", code: "LVA" },
    { value: "LEBANON", label: "Lebanon", code: "LBN" },
    { value: "LESOTHO", label: "Lesotho", code: "LSO" },
    { value: "LIBERIA", label: "Liberia", code: "LBR" },
    { value: "LIBYA", label: "Libya", code: "LBY" },
    { value: "LIECHTENSTEIN", label: "Liechtenstein", code: "LIE" },
    { value: "LITHUANIA", label: "Lithuania", code: "LTU" },
    { value: "LUXEMBOURG", label: "Luxembourg", code: "LUX" },
    { value: "MACAO", label: "Macao", code: "MAC" },
    { value: "MADAGASCAR", label: "Madagascar", code: "MDG" },
    { value: "MALAWI", label: "Malawi", code: "MWI" },
    { value: "MALAYSIA", label: "Malaysia", code: "MYS" },
    { value: "MALDIVES", label: "Maldives", code: "MDV" },
    { value: "MALI", label: "Mali", code: "MLI" },
    { value: "MALTA", label: "Malta", code: "MLT" },
    { value: "MARSHALL ISLANDS", label: "Marshall Islands", code: "MHL" },
    { value: "MARTINIQUE", label: "Martinique", code: "MTQ" },
    { value: "MAURITANIA", label: "Mauritania", code: "MRT" },
    { value: "MAURITIUS", label: "Mauritius", code: "MUS" },
    { value: "MAYOTTE", label: "Mayotte", code: "MYT" },
    { value: "MEXICO", label: "Mexico", code: "MEX" },
    { value: "MICRONESIA", label: "Micronesia", code: "FSM" },
    { value: "MOLDOVA", label: "Moldova", code: "MDA" },
    { value: "MONACO", label: "Monaco", code: "MCO" },
    { value: "MONGOLIA", label: "Mongolia", code: "MNG" },
    { value: "MONTENEGRO", label: "Montenegro", code: "MNE" },
    { value: "MONTSERRAT", label: "Montserrat", code: "MSR" },
    { value: "MOROCCO", label: "Morocco", code: "MAR" },
    { value: "MOZAMBIQUE", label: "Mozambique", code: "MOZ" },
    { value: "MYANMAR", label: "Myanmar", code: "MMR" },
    { value: "NAMIBIA", label: "Namibia", code: "NAM" },
    { value: "NAURU", label: "Nauru", code: "NRU" },
    { value: "NEPAL", label: "Nepal", code: "NPL" },
    { value: "NETHERLANDS", label: "Netherlands", code: "NLD" },
    { value: "NEW CALEDONIA", label: "New Caledonia", code: "NCL" },
    { value: "NEW ZEALAND", label: "New Zealand", code: "NZL" },
    { value: "NICARAGUA", label: "Nicaragua", code: "NIC" },
    { value: "NIGER", label: "Niger", code: "NER" },
    { value: "NIGERIA", label: "Nigeria", code: "NGA" },
    { value: "NIUE", label: "Niue", code: "NIU" },
    { value: "NORFOLK ISLAND", label: "Norfolk Island", code: "NFK" },
    { value: "NORTHERN MARIANA ISLANDS", label: "Northern Mariana Islands", code: "MNP" },
    { value: "NORWAY", label: "Norway", code: "NOR" },
    { value: "OMAN", label: "Oman", code: "OMN" },
    { value: "PAKISTAN", label: "Pakistan", code: "PAK" },
    { value: "PALAU", label: "Palau", code: "PLW" },
    { value: "PALESTINE, STATE OF", label: "Palestine, State of", code: "PSE" },
    { value: "PANAMA", label: "Panama", code: "PAN" },
    { value: "PAPUA NEW GUINEA", label: "Papua New Guinea", code: "PNG" },
    { value: "PARAGUAY", label: "Paraguay", code: "PRY" },
    { value: "PERU", label: "Peru", code: "PER" },
    { value: "PHILIPPINES", label: "Philippines", code: "PHL" },
    { value: "PITCAIRN", label: "Pitcairn", code: "PCN" },
    { value: "POLAND", label: "Poland", code: "POL" },
    { value: "PORTUGAL", label: "Portugal", code: "PRT" },
    { value: "PUERTO RICO", label: "Puerto Rico", code: "PRI" },
    { value: "QATAR", label: "Qatar", code: "QAT" },
    { value: "REPUBLIC OF NORTH MACEDONIA", label:"Republic of North Macedonia", code: "MKD"},
    { value: "REUNION", label: "Réunion", code: "REU" },
    { value: "ROMANIA", label: "Romania", code: "ROU" },
    { value: "RUSSIAN FEDERATION", label: "Russia", code: "RUS" },
    { value: "RWANDA", label: "Rwanda", code: "RWA" },
    { value: "SAINT BARTHELEMY", label: "Saint Barthélemy", code: "BLM" },
    { value: "SAINT HELENA", label: "Saint Helena", code: "SHN" },
    { value: "SAINT KITTS AND NEVIS", label: "Saint Kitts and Nevis", code: "KNA" },
    { value: "SAINT LUCIA", label: "Saint Lucia", code: "LCA" },
    { value: "SAINT MARTIN (FRENCH PART)", label: "Saint Martin (French part)", code: "MAF" },
    { value: "SAINT PIERRE AND MIQUELON", label: "Saint Pierre and Miquelon", code: "SPM" },
    { value: "SAINT VINCENT AND THE GRENADINES", label: "Saint Vincent and the Grenadines", code: "VCT" },
    { value: "SAMOA", label: "Samoa", code: "WSM" },
    { value: "SAN MARINO", label: "San Marino", code: "SMR" },
    { value: "SAO TOME AND PRINCIPE", label: "Sao Tome and Principe", code: "STP" },
    { value: "SAUDI ARABIA", label: "Saudi Arabia", code: "SAU" },
    { value: "SENEGAL", label: "Senegal", code: "SEN" },
    { value: "SERBIA", label: "Serbia", code: "SRB" },
    { value: "SEYCHELLES", label: "Seychelles", code: "SYC" },
    { value: "SIERRA LEONE", label: "Sierra Leone", code: "SLE" },
    { value: "SINGAPORE", label: "Singapore", code: "SGP" },
    { value: "SINT MAARTEN (DUTCH PART)", label: "Sint Maarten (Dutch part)", code: "SXM" },
    { value: "SLOVAKIA", label: "Slovakia", code: "SVK" },
    { value: "SLOVENIA", label: "Slovenia", code: "SVN" },
    { value: "SOLOMON ISLANDS", label: "Solomon Islands", code: "SLB" },
    { value: "SOMALIA", label: "Somalia", code: "SOM" },
    { value: "SOUTH AFRICA", label: "South Africa", code: "ZAF" },
    { value: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS", label: "South Georgia and the South Sandwich Islands", code: "SGS" },
    { value: "SOUTH SUDAN", label: "South Sudan", code: "SSD" },
    { value: "SPAIN", label: "Spain", code: "ESP" },
    { value: "SRI LANKA", label: "Sri Lanka", code: "LKA" },
    { value: "SUDAN", label: "Sudan", code: "SDN" },
    { value: "SURINAME", label: "Suriname", code: "SUR" },
    { value: "SVALBARD AND JAN MAYEN", label: "Svalbard and Jan Mayen", code: "SJM" },
    { value: "SWEDEN", label: "Sweden", code: "SWE" },
    { value: "SWITZERLAND", label: "Switzerland", code: "CHE" },
    { value: "SYRIAN ARAB REPUBLIC", label: "Syria", code: "SYR" },
    { value: "TAIWAN, PROVINCE OF CHINA", label: "Taiwan", code: "TWN" },
    { value: "TAJIKISTAN", label: "Tajikistan", code: "TJK" },
    { value: "TANZANIA", label: "Tanzania", code: "TZA" },
    { value: "THAILAND", label: "Thailand", code: "THA" },
    { value: "TIMOR-LESTE", label: "Timor-Leste", code: "TLS" },
    { value: "TOGO", label: "Togo", code: "TGO" },
    { value: "TOKELAU", label: "Tokelau", code: "TKL" },
    { value: "TONGA", label: "Tonga", code: "TON" },
    { value: "TRINIDAD AND TOBAGO", label: "Trinidad and Tobago", code: "TTO" },
    { value: "TUNISIA", label: "Tunisia", code: "TUN" },
    { value: "TURKEY", label: "Turkey", code: "TUR" },
    { value: "TURKMENISTAN", label: "Turkmenistan", code: "TKM" },
    { value: "TURKS AND CAICOS ISLANDS", label: "Turks and Caicos Islands", code: "TCA" },
    { value: "TUVALU", label: "Tuvalu", code: "TUV" },
    { value: "UGANDA", label: "Uganda", code: "UGA" },
    { value: "UKRAINE", label: "Ukraine", code: "UKR" },
    { value: "UNITED ARAB EMIRATES", label: "United Arab Emirates", code: "ARE" },
    { value: "UNITED KINGDOM", label: "United Kingdom", code: "GBR" },
    { value: "UNITED STATES MINOR OUTLYING ISLANDS", label: "United States Minor Outlying Islands", code: "UMI" },
    { value: "UNITED STATES OF AMERICA", label: "United States", code: "USA" },
    { value: "URUGUAY", label: "Uruguay", code: "URY" },
    { value: "UZBEKISTAN", label: "Uzbekistan", code: "UZB" },
    { value: "VANUATU", label: "Vanuatu", code: "VUT" },
    { value: "VENEZUELA", label: "Venezuela", code: "VEN" },
    { value: "VIET NAM", label: "Vietnam", code: "VNM" },
    { value: "VIRGIN ISLANDS BRITISH", label: "Virgin Islands (British)", code: "VGB"},
    { value: "VIRGIN ISLANDS US", label: "Virgin Islands (U.S.)", code: "VIR"},
    { value: "WALLIS AND FUTUNA", label: "Wallis and Futuna", code: "WLF"},
    { value: "WESTERN SAHARA", label: "Western Sahara", code: "ESH" },
    { value: "YEMEN", label: "Yemen", code: "YEM" },
    { value: "ZAMBIA", label: "Zambia", code: "ZMB" },
    { value: "ZIMBABWE", label: "Zimbabwe", code: "ZWE" }
];

export const adUnitTypeOptions = [
    {
        value: "INTERSTITIAL",
        label: "Interstitial",
    },
    {
        value: "BANNER",
        label: "Banner",
    },
    {
        value: "REWARDED",
        label: "Rewarded",
    },
    {
        value: "NATIVE",
        label: "Native",
    },
    {
        value: "VIDEO",
        label: "Video",
    },
];

export const adUnitFormatOptions = [
    { value: "all", label: "ALL" },
    { value: "banner", label: "BANNER" },
    { value: "native", label: "NATIVE" },
    { value: "interstitial", label: "INTERSTITIAL" },
    { value: "rewarded", label: "REWARDED" },
    { value: "video", label: "VIDEO" },
]
export const platformOptions = [
    {
       value: "android",
       label: "ANDROID",
    },
    {
        value: "ios",
        label: "IOS",
    },
    {
        value: "web",
        label: "WEB",
    }
    // {
    //     value: "APP",
    //     label: "App",
    // },
    // {
    //     value: "VID",
    //     label: "Video",
    // },
    // {
    //     value: "WEB",
    //     label: "Web",
    // },
];
